import { t } from 'utils/i18n';

const requiredField = (name) => {
  return `${t('pleaseSpecify')} ${t(name).toLowerCase()}`;
};

export default requiredField;
